(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tabbed-multicolumn"] && !Shopify.designMode) return;
  try {
    
(function () {
  function activate(root, id) {
    if (!root || id == null) return;
    root.querySelectorAll('[data-tab]').forEach(function (t) {
      var on = t.getAttribute('data-tab') === String(id);
      t.classList.toggle('is-active', on);
      t.setAttribute('aria-selected', on ? 'true' : 'false');
      t.setAttribute('tabindex', on ? '0' : '-1');
    });
    root.querySelectorAll('[data-tab-panel]').forEach(function (p) {
      var on = p.getAttribute('data-tab-panel') === String(id);
      p.classList.toggle('is-active', on);
      if (on) { p.removeAttribute('hidden'); } else { p.setAttribute('hidden', ''); }
    });
  }

  // Point the card's quick add at the variant for the clicked colour
  function syncQuickAddVariant(card, sw) {
    var host = card.querySelector('.tmc-qa');
    if (!host) return;
    var link = host.querySelector('.tmc-qa__link');
    if (!link) return;

    var map = {};
    try { map = JSON.parse(host.getAttribute('data-color-variants') || '{}'); } catch (e) { map = {}; }

    var variantUrl = map[sw.getAttribute('title')];
    if (variantUrl) link.setAttribute('href', variantUrl);
  }

  // Select a swatch: mark active and swap the card image to the variant image.
  // If the swatch has no variant image, leave the card image unchanged.
  function selectSwatch(sw) {
    if (!sw || sw.classList.contains('tmc-swatch--more')) return;
    var card = sw.closest('.tmc-pcard');
    if (!card) return;

    var group = sw.closest('.tmc-pcard__swatches');
    if (group) {
      group.querySelectorAll('.tmc-swatch').forEach(function (s) {
        if (!s.classList.contains('tmc-swatch--more')) s.classList.toggle('is-active', s === sw);
      });
    }

    syncQuickAddVariant(card, sw);

    var url = sw.getAttribute('data-variant-image');
    if (!url) return; // no variant image -> do not update the image

    var img = card.querySelector('.tmc-pcard__img');
    if (!img) return;
    if (!card._origSrc) {
      card._origSrc = img.getAttribute('src') || '';
      card._origSrcset = img.getAttribute('srcset') || '';
    }
    img.removeAttribute('srcset');
    img.removeAttribute('sizes');
    img.src = url;
  }

  // Product handle from a link like /products/handle (also handles locale / collection prefixes)
  function productHandleFromHref(href) {
    if (!href) return null;
    try {
      var path = new URL(href, window.location.origin).pathname;
      var match = path.match(/\/products\/([^\/]+)\/?$/);
      return match ? decodeURIComponent(match[1]) : null;
    } catch (e) {
      return null;
    }
  }

  // Attach each quick add template to the image of the card for the same product
  function attachQuickAdd(root) {
    root.querySelectorAll('[data-pcarousel]').forEach(function (carousel) {
      var cards = Array.prototype.slice.call(carousel.querySelectorAll('a.tmc-pcard'));

      carousel.querySelectorAll('template[data-tmc-qa]').forEach(function (tpl) {
        var handle = tpl.getAttribute('data-handle');
        if (!handle) return;

        var card = null;
        for (var i = 0; i < cards.length; i++) {
          if (cards[i].querySelector('.tmc-qa')) continue;
          if (productHandleFromHref(cards[i].getAttribute('href')) === handle) {
            card = cards[i];
            break;
          }
        }
        if (!card) return;

        var media = card.querySelector('.tmc-pcard__media');
        if (!media) return;
        media.appendChild(tpl.content.cloneNode(true));
      });
    });
  }

  function initSection(root) {
    if (!root) return;
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-tab]'));
    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () { activate(root, tab.getAttribute('data-tab')); });
      tab.addEventListener('keydown', function (e) {
        var dir = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
        if (!dir) return;
        e.preventDefault();
        var nextTab = tabs[(i + dir + tabs.length) % tabs.length];
        nextTab.focus();
        activate(root, nextTab.getAttribute('data-tab'));
      });
    });

    attachQuickAdd(root);

    // Swatch interactions (delegated, bound once per section root)
    if (!root._tmcSwatchBound) {
      root._tmcSwatchBound = true;
      root.addEventListener('click', function (e) {
        var sw = e.target.closest('.tmc-swatch');
        if (!sw || sw.classList.contains('tmc-swatch--more')) return;
        e.preventDefault();
        e.stopPropagation();
        selectSwatch(sw);
      });
      root.addEventListener('keydown', function (e) {
        if (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar') return;
        var sw = e.target.closest('.tmc-swatch');
        if (!sw || sw.classList.contains('tmc-swatch--more')) return;
        e.preventDefault();
        e.stopPropagation();
        selectSwatch(sw);
      });
    }
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-section-type="tabbed-multicol"]').forEach(initSection);
  }

  if (document.readyState !== 'loading') { initAll(); }
  else { document.addEventListener('DOMContentLoaded', function () { initAll(); }); }

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });

  document.addEventListener('shopify:block:select', function (e) {
    var root = e.target.closest('[data-section-type="tabbed-multicol"]');
    if (!root) return;
    var refEl = e.target.matches('[data-tab-ref]') ? e.target : e.target.querySelector('[data-tab-ref]');
    var ref = refEl && refEl.getAttribute('data-tab-ref');
    if (ref) activate(root, ref);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
